(function(){
"use strict";

(function(){
  var st = document.createElement("style");
  st.textContent =
    ".root-landing .capa{max-width:none !important;height:auto !important;min-width:0 !important}" +
    ".root-landing .logo img{max-width:none !important}" +
    ".root-landing model-viewer{max-width:none !important}";
  document.head.appendChild(st);
})();

var raiz    = document.querySelector(".root-landing");
var mascota = document.getElementById("mascota");
var mv      = document.getElementById("mv3d");
var fondo   = document.getElementById("fondo");
var mundo   = document.querySelector(".mundo");
var capaA   = document.querySelector(".franjaA");
var capaB   = document.querySelector(".franjaB");
var paneles = [].slice.call(document.querySelectorAll(".panel"));
if (!raiz || !mascota || !fondo) return;

(function(){
  var n = raiz.parentElement;
  while (n && n !== document.documentElement){
    var cs = window.getComputedStyle(n);
    if (cs.transform !== "none" || cs.filter !== "none" || cs.perspective !== "none" ||
        (cs.contain && cs.contain !== "none")){
      n.style.setProperty("transform", "none", "important");
      n.style.setProperty("filter", "none", "important");
      n.style.setProperty("perspective", "none", "important");
      n.style.setProperty("contain", "none", "important");
    }
    n = n.parentElement;
  }
})();

var movil = window.matchMedia("(max-width: 768px)");
var baseY = movil.matches ? 0.30 : 0.44;
var GIRO_BASE = 0.050, CHIP_F = 0.8265, DOCK_F = 0.79, F = 0.030;

var topDoc = 0, altura = 0, vh = window.innerHeight;
var avisado = false, ultMedida = 0;

function medir(){
  ultMedida = Date.now();
  var w = fondo.offsetWidth;
  if (!w) return;
  var h = fondo.offsetHeight;

  if (mundo) mundo.style.height = h + "px";
  if (capaA){ capaA.style.width = (w * 0.500).toFixed(1) + "px"; capaA.style.top = (w * 0.6235).toFixed(1) + "px"; }
  if (capaB){ capaB.style.width = (w * 1.000).toFixed(1) + "px"; capaB.style.top = (w * 1.1592).toFixed(1) + "px"; }

  var r = fondo.getBoundingClientRect();
  topDoc = r.top + window.scrollY;
  altura = r.height;
  vh = window.innerHeight;
  baseY = movil.matches ? 0.30 : 0.44;

  if (!avisado && window.console){
    avisado = true;
    console.log("[ROOT] ancho:", Math.round(w), "alto:", Math.round(h), "paneles:", paneles.length);
  }
}
medir();
window.addEventListener("resize", medir);
window.addEventListener("load", medir);
if (!fondo.complete) fondo.addEventListener("load", medir);
setTimeout(medir, 300); setTimeout(medir, 1200); setTimeout(medir, 3000);

var yActual = baseY * vh, theta = 20, vGiro = GIRO_BASE;
var ultScroll = window.scrollY, t0 = performance.now(), tPrev = t0, tCam = 0;
var previo = [], opPrev = -1;
var rangos = paneles.map(function(el, i){
  previo[i] = -1;
  return { el: el, ini: parseFloat(el.getAttribute("data-in")), fin: parseFloat(el.getAttribute("data-out")) };
});

function suave(x){ x = x < 0 ? 0 : (x > 1 ? 1 : x); return x * x * (3 - 2 * x); }
function tope(v, m){ return v > m ? m : (v < -m ? -m : v); }

function loop(t){
  var dt = Math.min(64, t - tPrev); tPrev = t;

  /* si aun no hay geometria, reintentar como mucho cada 300 ms */
  if (altura <= 0){
    if (Date.now() - ultMedida > 300) medir();
    requestAnimationFrame(loop);
    return;
  }

  var sy = window.scrollY;
  var rtop = topDoc - sy;
  var f = (baseY * vh - rtop) / altura;

  var destino = (f > DOCK_F) ? rtop + CHIP_F * altura - mascota.offsetHeight / 2 : baseY * vh;
  if (destino < 0.08 * vh) destino = 0.08 * vh;
  yActual += (destino - yActual) * 0.12;

  var vel = sy - ultScroll; ultScroll = sy;
  vGiro += (GIRO_BASE + tope(vel * 0.010, 0.9) - vGiro) * 0.08;
  theta += vGiro * dt;

  if (mv && t - tCam > 50){
    tCam = t;
    mv.setAttribute("camera-orbit", theta.toFixed(1) + "deg 80deg 108%");
  }

  var flot = Math.sin((t - t0) / 700) * 4;
  var lade = tope(vel * 0.25, 7);
  if (!mascota.classList.contains("brinco")){
    mascota.style.transform = "translate3d(-50%," + flot.toFixed(1) + "px,0) rotate(" + lade.toFixed(1) + "deg)";
  }
  mascota.style.top = yActual.toFixed(1) + "px";
  mascota.classList.toggle("dock", f > 0.78);

  var op = Math.round((f > 0.95 ? Math.max(0, 1 - (f - 0.95) / 0.08) : 1) * 100) / 100;
  if (op !== opPrev){ opPrev = op; mascota.style.opacity = op; }

  for (var i = 0; i < rangos.length; i++){
    var s = rangos[i];
    var v = Math.round(Math.min(suave((f - s.ini) / F), suave((s.fin - f) / F)) * 100) / 100;
    if (v !== previo[i]){
      previo[i] = v;
      s.el.style.opacity = v;
      s.el.style.pointerEvents = v > 0.6 ? "auto" : "none";
      s.el.style.visibility = v > 0.01 ? "visible" : "hidden";
    }
  }
  requestAnimationFrame(loop);
}

var ocupado = false, x0 = 0, y0 = 0, rec = 0, abajo = false;
function brincar(){
  if (ocupado) return;
  ocupado = true; vGiro = 1.05;
  mascota.classList.add("brinco");
  setTimeout(function(){ mascota.classList.remove("brinco"); ocupado = false; }, 920);
}
mascota.addEventListener("pointerdown", function(e){ abajo = true; rec = 0; x0 = e.clientX; y0 = e.clientY; });
mascota.addEventListener("pointermove", function(e){
  if (!abajo) return;
  rec += Math.abs(e.clientX - x0) + Math.abs(e.clientY - y0);
  x0 = e.clientX; y0 = e.clientY;
}, { passive: true });
mascota.addEventListener("pointerup", function(){ if (abajo && rec < 10) brincar(); abajo = false; });
mascota.addEventListener("pointercancel", function(){ abajo = false; });

var CAL_URL = raiz.getAttribute("data-cal") || "";
var modal = document.getElementById("modalCita");
var modalCal = document.getElementById("modalCal");
function abrirCita(ev){
  if (ev) ev.preventDefault();
  if (!modal) return;
  if (CAL_URL && modalCal && !modalCal.querySelector("iframe")){
    modalCal.innerHTML = '<iframe src="' + CAL_URL + '" title="Booking calendar" loading="lazy"></iframe>';
  }
  modal.hidden = false;
  document.body.style.overflow = "hidden";
}
function cerrarCita(){ if (!modal) return; modal.hidden = true; document.body.style.overflow = ""; }
var citas = document.querySelectorAll("[data-cita]");
for (var c = 0; c < citas.length; c++) citas[c].addEventListener("click", abrirCita);
if (modal){
  var cierres = modal.querySelectorAll("[data-cerrar]");
  for (var q = 0; q < cierres.length; q++) cierres[q].addEventListener("click", cerrarCita);
  document.addEventListener("keydown", function(e){ if (e.key === "Escape") cerrarCita(); });
}

var saltos = document.querySelectorAll("[data-ir]");
for (var s2 = 0; s2 < saltos.length; s2++){
  saltos[s2].addEventListener("click", function(ev){
    ev.preventDefault();
    var frac = parseFloat(this.getAttribute("data-ir"));
    window.scrollTo({ top: Math.max(0, topDoc + frac * altura - baseY * vh), behavior: "smooth" });
  });
}

var pistas = document.getElementById("heroPistas");
var puntos = document.getElementById("heroPuntos");
if (pistas && puntos){
  var bolas = puntos.querySelectorAll(".punto");
  pistas.addEventListener("scroll", function(){
    var i = Math.round(pistas.scrollLeft / Math.max(1, pistas.clientWidth));
    for (var b = 0; b < bolas.length; b++) bolas[b].classList.toggle("activo", b === i);
  }, { passive: true });
}

var flechas = document.querySelectorAll(".flecha");
for (var k = 0; k < flechas.length; k++){
  flechas[k].addEventListener("click", function(){
    var pista = document.getElementById(this.getAttribute("data-slider"));
    if (!pista) return;
    var tarjeta = pista.firstElementChild;
    var paso = tarjeta ? tarjeta.getBoundingClientRect().width + 18 : 300;
    pista.scrollBy({ left: paso * parseInt(this.getAttribute("data-dir"), 10), behavior: "smooth" });
  });
}

requestAnimationFrame(loop);
})();
